const siteHeader = document.querySelector(".site-header");
const navToggle = document.querySelector(".nav-toggle");
const siteNav = document.querySelector(".site-nav");
const navLinks = document.querySelectorAll(".site-nav a");
const revealItems = document.querySelectorAll(".reveal");
const filterGroup = document.querySelector("[data-filter-group]");
const filterButtons = document.querySelectorAll("[data-filter]");
const styleCards = document.querySelectorAll("[data-style-card]");
const demoForm = document.querySelector("[data-demo-form]");
const formNote = document.querySelector("[data-form-note]");

if (navToggle && siteHeader && siteNav) {
  navToggle.addEventListener("click", () => {
    const isOpen = siteHeader.classList.toggle("is-open");
    navToggle.setAttribute("aria-expanded", String(isOpen));
  });

  navLinks.forEach((link) => {
    link.addEventListener("click", () => {
      siteHeader.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
    });
  });

  document.addEventListener("click", (event) => {
    if (!siteHeader.contains(event.target)) {
      siteHeader.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      siteHeader.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
    }
  });
}

if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.18,
      rootMargin: "0px 0px -48px 0px",
    }
  );

  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add("is-visible"));
}

if (filterGroup && filterButtons.length && styleCards.length) {
  filterGroup.addEventListener("click", (event) => {
    const button = event.target.closest("[data-filter]");
    if (!button) {
      return;
    }

    const selected = button.dataset.filter || "all";

    filterButtons.forEach((item) => {
      const isActive = item === button;
      item.classList.toggle("is-active", isActive);
      item.setAttribute("aria-pressed", String(isActive));
    });

    styleCards.forEach((card) => {
      const category = card.dataset.category || "";
      const shouldShow = selected === "all" || category === selected;
      card.classList.toggle("is-hidden", !shouldShow);
    });
  });

  filterButtons.forEach((button, index) => {
    button.setAttribute("aria-pressed", String(index === 0));
  });
}

if (demoForm && formNote && window.location.protocol === "file:") {
  demoForm.addEventListener("submit", (event) => {
    event.preventDefault();
    formNote.textContent =
      "Thanks. Your project brief has been captured in this front-end prototype.";
    formNote.classList.add("is-success");
    demoForm.reset();
  });
}
